import PageMain from "./PageMain";
import { PageTwo } from "./PageTwo";

const ReportPreview = ({ page, reportDetails, reportChartRadonValue }) => {
  return (
    <div>
      {/*{page === 1 && (*/}
        <div
          className="pdf-body"
          style={{
            padding: "25px 25px 5px",
            height: "100%",
            border: "1px solid #E6E8F0",
            backgroundColor: "white",
          }}
        >
          <PageMain
            reportDetails={reportDetails}
            reportChartRadonValue={reportChartRadonValue}
            isForPDF={false}
          />
        </div>
      {/*)}*/}
      {/*{page === 2 && (*/}
      {/*  <div*/}
      {/*    className="pdf-body-two"*/}
      {/*    style={{*/}
      {/*      padding: "25px 25px 5px",*/}
      {/*      height: "100%",*/}
      {/*      border: "1px solid #E6E8F0",*/}
      {/*      backgroundColor: "white",*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <PageTwo*/}
      {/*      reportDetails={reportDetails}*/}
      {/*      reportChartRadonValue={reportChartRadonValue}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
};

export default ReportPreview;
